export const CONSTRUCTOR_MODE = 'constructor';
export const DEFAULT_MODE = 'main';
export const VIEW_MODE = 'view';
